"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _AccordionContext = require("./AccordionContext");

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Accordion = props => {
  const {
    prefix,
    children,
    className,
    collapsible,
    padded,
    ...other
  } = props;
  const classes = (0, _classnames.default)(`${prefix}accordion`, padded && `${prefix}accordion--padded`, className);

  const childrenArray = _react.Children.toArray(children);

  const focusRef = (0, _react.useRef)(null);
  const [selected, setSelected] = (0, _react.useState)(-1);
  const initOpen = {};
  const disabledChildren = [];
  childrenArray.forEach((child, i) => {
    initOpen[child.props.id] = !!child.props.open;
    disabledChildren[i] = child.props.disabled;
  });
  const [openedItems, setOpenedItems] = (0, _react.useState)(initOpen);
  const [disabledItems, setDisabledItems] = (0, _react.useState)(disabledChildren);
  const context = (0, _react.useMemo)(() => ({
    focusRef,
    selected,
    setSelected,
    openedItems,
    setOpenedItems,
    disabledItems,
    setDisabledItems,
    collapsible
  }), [openedItems, disabledItems, selected, setSelected]);
  return _react.default.createElement("ul", _extends({
    className: classes
  }, other), _react.default.createElement(_AccordionContext.AccordionProvider, {
    value: context
  }, childrenArray.filter(c => c).map((child, i) => (0, _react.cloneElement)(child, {
    index: i,
    key: child.key || i
  }))));
};

Accordion.defaultProps = {
  collapsible: true,
  prefix: '',
  padded: false
};
var _default = Accordion;
exports.default = _default;